module.exports = __webpack_public_path__ + "img/portraits_11_V.ae24a42a.webp";